export const ALL_ACCESS = ['admin']
export const DASHBOARD = ['admin', 'supervisor', 'reporter']
export const REPORT = ['admin', 'supervisor', 'reporter']
export const CRUD = ['admin', 'supervisor']
export const IN_OUT = ['admin', 'supervisor', 'crew']
export const WEB_ACCESS = ['admin', 'supervisor', 'reporter', 'crew']